import { ElementType, ReactNode } from "react";

import { cn } from "@verse_core/shared_components/ClassName";

type BodyProps = {
  children: ReactNode;
  className?: string;
  dataTestId?: string;
  as?: ElementType;
};

export const BodyLG = ({
  children,
  className,
  as: Component = "p",
  dataTestId,
}: BodyProps) => {
  return (
    <Component
      className={cn(
        "tw-font-dm-sans tw-text-[1em] tw-font-light tw-leading-[150%] tw-tracking-[-1%] tw-text-gray-0",
        className,
      )}
      data-testid={dataTestId}
    >
      {children}
    </Component>
  );
};
